export default "__VITE_ASSET__DHAWFUa$__"